export default {
    default: {
        fetchModelsPeriod: 30000, // définit le temps en ms entre chaque fetch
    },
    listModels: {
        alerts: {
            url: 'alert/',
        },
        alarms: {
            url: 'alarm/',
        },
        users: {
            url: 'user/',
        },
        groups: {
            url: 'group/',
        },
        entities: {
            url: 'entity/',
        },
        takers: {
            url: 'taker/',
            filter: {
                archived: false
            }
        },
        adminNotifConfigs:{
            url: 'admin-notif-config/',
            fetch: false,
        },
        adminNotifSubjects:{
            url: 'admin-notif-subject/',
            fetch: true,
        },
        adminNotifRequest:{
            url: 'admin-notif-request/',
            fetch: false,
        },
        feeds: {
            url: 'feed/',
            scoped: true,
            fetch: false,
        },
        awsregions: {
            url: 'awsregion/',
        },
        broadcastRight: {
            url: 'broadcast-right/',
            fetch: false
        },
        configurations: {
            url: 'configuration/',
            scoped: true,
            fetch: false,
        },
        tags: {
            url: 'tag/',
            scoped: true,
            fetch: false,
        },
        events: {
            url: 'event/',
            scoped: true,
            fetch: false,
            filter: {
                archived: false
            }
        },
        universes: {
            url: 'universe/',
            scoped: true,
            fetch: false,
        },
        irds: {
            url: 'ird/',
            scoped: false,
            filter: {
                archived: false,
                c_resp_nested: true,
            }
        },
        deliveryFlowStats: {
            url: 'delivery-flow-stat/',
            scoped: true,
            fetch: false,
        },
        deliveryMonitorings: {
            url: 'delivery-monitoring/',
            fetch: false,
        },
        dispatchMonitorings: {
            url: 'dispatch-monitoring/',
            fetch: false,
        },
        takerGroups: {
            url: 'taker-group/',
            scoped: false,
            fetch: true,
        },
        manualReceivers: {
            url: 'manual-receiver/',
            filter: {
                archived: false,
            }
        },
        bookingMismatches: {
            url: 'booking-mismatch/',
            fetch: false,
        },
        ConsumptionByFeeds: {
            url: 'consumption-by-feed/',
            scoped: true,
            fetch: false,
        },
        consumptionByDays: {
            url: 'consumption-by-day/',
            scoped: true,
            fetch: false,
        },
        feedAdminMonitors: {
            url: 'feed-admin-monitor/',
            fetch: false,
        },
        feedManagerMonitors: {
            url: 'feed-manager-monitor/',
            fetch: false,
        },
        kickTakerRequests: {
            url: 'kick-taker-request/',
            fetch: false,
        },
        feedModificationRequests: {
            url: 'feed-modification-request/',
            fetch: false,
        },
        hwTypes: {
            url: 'hwtype/',
        },
        zixiReceivers: {
            url: 'zixi-receiver/'
        },
        videoSources: {
            url: 'video-source/',
            fetch: false,
        },
        latencies: {
            url: 'latency/',
        },
        channels: {
            url: 'channel/',
            fetch: false,
        },
        channelModificationRequests: {
            url: 'channel-modification-request/',
            fetch: false,
        },
        parameters: {
            url: 'parameter/',
            fetch: false
        },
        schedulings: {
            url: 'scheduling/',
            fetch: false
        },
        schedulingModificationRequest: {
            url: 'scheduling-modification-request/',
            fetch: false
        },
        schedulingCreationRequest: {
            url: 'scheduling-creation-request/',
            fetch: false
        },
        blankingProfiles: {
            url: 'blanking-profile/',
            fetch: false
        },
        previewCreationRequest:{
            url: 'preview-creation-request/',
            fetch: false
        },
        previewModificationRequest:{
            url: 'preview-modification-request/',
            fetch: false
        },
        BlankingExport: {
            url: 'blanking-export/',
            fetch: false
        },
        channelAdminMonitors: {
            url: 'channel-admin-monitor/',
            fetch: false,
        },
        channelManagerMonitors: {
            url: 'channel-manager-monitor/',
            fetch: false,
        },
        reconfiguration:{
            url: 'reconfiguration/',
            fetch: false,
        },
        datacenters:{
            url: 'datacenter/',
        },
        ips:{
            url: 'ip/',
            fetch: false,
            filter: {
                archived: false,
            }
        },
        channelSupervisions:{
            url: 'channel-supervision/',
            fetch: false,
        },
        receiverPortRequests:{
            url: 'receiver-port-request/',
            fetch: false,
        },
        receiverCreationRequest:{
            url: 'receiver-creation-request/',
            fetch: false,
        },
        receiverModificationRequest:{
            url: 'receiver-modification-request/',
            fetch: false,
        },
        takerModificationRequests:{
            url: 'taker-modification-request/',
            fetch: false,
        },
        feedResources:{
            url: 'feed-resource/',
            fetch: false,
        },
        feedResourceModificationRequests:{
            url: 'feed-resource-modification-request/',
            fetch: false,
        },
        feedResourceConfigurations:{
            url: 'feed-resource-configuration/',
            fetch: false,
        },
        configurationModificationRequests:{
            url:'configuration-modification-request/',
            fetch: false,
        },
        userManagementRequests:{
            url: 'user-management-request/',
            fetch: false,
        },
        importFeedRequest:{
            url: 'import-feed-request/',
            fetch: false,
        },
        exportConfigurationRequests:{
            url: 'export-configuration-request/',
            fetch: false,
        },
    },
};



// WEBPACK FOOTER //
// ./src/store/meta.js